export type ToolMatcher = (toolName: string) => boolean;

/**
 * Builds a matcher that accepts both bare and Mastra-namespaced tool names.
 * Mastra prefixes tools with the provider id (e.g. `provider_searchHotels`),
 * so anywhere we filter records by tool kind we need to match both forms.
 *
 * The single-name fast path precomputes the `_${name}` suffix so the closure
 * does no allocation per call — used on hot paths like resolver record loops.
 */
export function createToolMatcher(toolNames: string | string[]): ToolMatcher {
  if (typeof toolNames === 'string') {
    const suffix = `_${toolNames}`;
    return name => name === toolNames || name.endsWith(suffix);
  }
  const exact = new Set(toolNames);
  const suffixes = toolNames.map(n => `_${n}`);
  return name => exact.has(name) || suffixes.some(s => name.endsWith(s));
}
